import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { Fragment, memo } from 'react';
import { ReactSortable } from 'react-sortablejs';
function SortableListImpl(props) {
    const { list, children, ...rest } = props;
    return (_jsx(Box, { sx: (theme) => ({
            '& .sortable-list-ghost': {
                opacity: 0.7,
                backgroundColor: theme.palette.secondary.light,
                color: theme.palette.secondary.light,
            },
        }), children: _jsx(ReactSortable, { list: list, animation: 200, delay: 80, scroll: true, scrollSpeed: 20, scrollSensitivity: 150, forceFallback: true, ...rest, children: list.map((panel) => (_jsx(Fragment, { children: panel.component }, panel.id))) }) }));
}
export const SortableList = memo(SortableListImpl);
